import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchCreateOrEditImportHorseFrozenSemenServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchGetShippingAgentsthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import EahsForm from "../components/EahsForm";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";

export default function ImportHorseFrozenSemen() {
  //env 
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { studBookCountries, currentLanguage } = useSelector((state) => state.studBookSlice);

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    importHorseFrozenSemenData,
    getShippingAgentsData,
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    importHorseFrozenSemenId: "",
    eventName: "",
    comment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    importCountry: "",
    importCountryDrop: {
      label: translate("web.chooseCountry", "Choose Country"),
      value: null,
    },

    originCountry: "",
    originCountryDrop: {
      label: translate("web.chooseCountry", "Choose Country"),
      value: null,
    },

    stallionName: "",
    horseCategory: "Show",
    ueln: "",

    sire: "",
    dam: "",
    originStudbookRefNo: "",
    currentStudbookRefNo: "",
    approvedCollectionCenter: "",
    noStraws: null,
    noDoses: null,
    dispatchNumber: "",
    importDate: null,
    uaeHospitalSemenStocking: "",
    shippingAgent: "",
    shippingAgentDrop: {
      label: translate("web.shippingAgent", "Shipping Agent"),
      value: null,
    },
    shippingAgentNameEn: "",
    shippingAgentNameAr: "",
    shippingAgentMobile: "",
    shippingAgentEmail: "",

    ownerComment: "",

    filePathHorsePassport: "",
    fileTypeHorsePassport: "",
    fileNameHorsePassport: "",
    fileUrlHorsePassport: "",
    horsePassportAttachmentFile: null,

    filePathLetterSemenStorageCenter: "",
    fileTypeLetterSemenStorageCenter: "",
    fileNameLetterSemenStorageCenter: "",
    fileUrlLetterSemenStorageCenter: "",
    letterSemenStorageCenterAttachmentFile: null,

    filePathResidencePermit: "",
    fileTypeResidencePermit: "",
    fileNameResidencePermit: "",
    fileUrlResidencePermit: "",
    residencePermitAttachmentFile: null,
  });

  const [errorStallionName, setErrorStallionName] = useState(false);
  const [errorImportCountry, setErrorImportCountry] = useState(false);
  const [errorOriginCountry, setErrorOriginCountry] = useState(false);
  const [errorUeln, setErrorUeln] = useState(false);
  const [errorSire, setErrorSire] = useState(false);
  const [errorDam, setErrorDam] = useState(false);
  const [errorShippingAgentNameEn, setErrorShippingAgentNameEn] = useState(false);
  const [errorShippingAgentNameAr, setErrorShippingAgentNameAr] = useState(false);
  const [errorShippingAgentMobile, setErrorShippingAgentMobile] = useState(false);
  const [errorShippingAgentEmail, setErrorShippingAgentEmail] = useState(false);
  const [errorOriginStudbookRefNo, setErrorOriginStudbookRefNo] = useState(false);
  const [errorCurrentStudbookRefNo, setErrorCurrentStudbookRefNo] = useState(false);
  const [errorApprovedCollectionCenter, setErrorApprovedCollectionCenter] = useState(false);
  const [errorNoStraws, setErrorNoStraws] = useState(false);
  const [errorNoDoses, setErrorNoDoses] = useState(false);
  const [errorDispatchNumber, setErrorDispatchNumber] = useState(false);
  const [errorUaeHospitalSemenStocking, setErrorUaeHospitalSemenStocking] = useState(false);
  const [errorImportDate, setErrorImportDate] = useState(false);
  const [errorShippingAgent, setErrorShippingAgent] = useState(false);
  const [errorHorsePassport, setErrorHorsePassport] = useState(false);
  const [errorLetterSemenStorageCenter, setErrorLetterSemenStorageCenter] = useState(false);
  const [errorResidencePermit, setErrorResidencePermit] = useState(false);
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  //use ref
  const stallionNameRef = useRef(null);
  const importCountryRef = useRef(null);
  const originCountryRef = useRef(null);
  const sireRef = useRef(null);
  const damRef = useRef(null);
  const shippingAgentNameEnRef = useRef(null);
  const shippingAgentNameArRef = useRef(null);
  const shippingAgentMobileRef = useRef(null);
  const shippingAgentEmailRef = useRef(null);
  const originStudbookRefNoRef = useRef(null);
  const currentStudbookRefNoRef = useRef(null);
  const approvedCollectionCenterRef = useRef(null);
  const noStrawsRef = useRef(null);
  const noDosesRef = useRef(null);
  const dispatchNumberRef = useRef(null);
  const uaeHospitalSemenStockingRef = useRef(null);
  const importDateRef = useRef(null);
  const shippingAgentRef = useRef(null);
  const horsePassportRef = useRef(null);
  const letterSemenStorageCenterRef = useRef(null);

  const [
    horsePassportAttachmentFile,
    setHorsePassportAttachmentFile,
  ] = useState([]);

  const [
    letterSemenStorageCenterAttachmentFile,
    setLetterSemenStorageCenterAttachmentFile,
  ] = useState([]);

  const [
    residencePermitAttachmentFile,
    setResidencePermitAttachmentFile,
  ] = useState([]);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");
  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false,
  //   option3: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //function

  const handleFormChange = (e, input) => {
    if (input === "importCountry") {
      setFormModel({
        ...formModel,
        importCountry: e.value,
        importCountryDrop: e,
      });
    }
    else if (input === "originCountry") {
      setFormModel({
        ...formModel,
        originCountry: e.value,
        originCountryDrop: e,
      });
    }
    else if (input === "shippingAgent") {
      setFormModel({
        ...formModel,
        shippingAgent: e.value,
        shippingAgentDrop: e,
      });
    }
    else if (input === "stallionName" || input === "sire" || input === "dam") {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value.toUpperCase(),
      });
    }
    else if (!!input && input === "shippingAgentNameEn") {
      const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;

      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          shippingAgentNameEn: e.target.value,
        });
      }
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const setPhoneNumber = (value) => {
    setFormModel((prev) => ({
      ...prev,
      shippingAgentMobile: value
    }));
  }

  const handleUploadHorsePassportChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          horsePassportAttachmentFile: e.target.files[0],
        });

        setHorsePassportAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const handleUploadLetterSemenStorageCenterChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          letterSemenStorageCenterAttachmentFile: e.target.files[0],
        });

        setLetterSemenStorageCenterAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const handleUploadResidencePermitChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          residencePermitAttachmentFile: e.target.files[0],
        });

        setResidencePermitAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.stallionName === ""
    ) {
      setErrorStallionName(true);
      valid = false;

      stallionNameRef?.current?.focus();
      return;
    }
    else {
      setErrorStallionName(false);
    }

    if (
      formModel.importCountry === ""
    ) {
      setErrorImportCountry(true);
      valid = false;

      importCountryRef?.current?.focus();
      return;
    }
    else {
      setErrorImportCountry(false);
    }

    if (
      formModel.originCountry === ""
    ) {
      setErrorOriginCountry(true);
      valid = false;

      originCountryRef?.current?.focus();
      return;
    }
    else {
      setErrorOriginCountry(false);
    }

    if (
      formModel.sire === ""
    ) {
      setErrorSire(true);
      valid = false;

      sireRef?.current?.focus();
      return;
    }
    else {
      setErrorSire(false);
    }

    if (
      formModel.dam === ""
    ) {
      setErrorDam(true);
      valid = false;

      damRef?.current?.focus();
      return;
    }
    else {
      setErrorDam(false);
    }

    if (
      formModel.originStudbookRefNo === ""
    ) {
      setErrorOriginStudbookRefNo(true);
      valid = false;

      originStudbookRefNoRef?.current?.focus();
      return;
    }
    else {
      setErrorOriginStudbookRefNo(false);
    }

    if (
      formModel.currentStudbookRefNo === ""
    ) {
      setErrorCurrentStudbookRefNo(true);
      valid = false;

      currentStudbookRefNoRef?.current?.focus();
      return;
    }
    else {
      setErrorCurrentStudbookRefNo(false);
    }

    if (
      formModel.approvedCollectionCenter === ""
    ) {
      setErrorApprovedCollectionCenter(true);
      valid = false;

      approvedCollectionCenterRef?.current?.focus();
      return;
    }
    else {
      setErrorApprovedCollectionCenter(false);
    }

    if (
      formModel.noStraws === "" || formModel.noStraws == null || Number(formModel.noStraws) < 1
    ) {
      setErrorNoStraws(true);
      valid = false;

      noStrawsRef?.current?.focus();
      return;
    }
    else {
      setErrorNoStraws(false);
    }

    if (
      formModel.noDoses === "" || formModel.noStraws == null || Number(formModel.noDoses) < 1
    ) {
      setErrorNoDoses(true);
      valid = false;

      noDosesRef?.current?.focus();
      return;
    }
    else {
      setErrorNoDoses(false);
    }

    if (
      formModel.dispatchNumber === ""
    ) {
      setErrorDispatchNumber(true);
      valid = false;

      dispatchNumberRef?.current?.focus();
      return;
    }
    else {
      setErrorDispatchNumber(false);
    }

    if (
      formModel.uaeHospitalSemenStocking === ""
    ) {
      setErrorUaeHospitalSemenStocking(true);
      valid = false;

      uaeHospitalSemenStockingRef?.current?.focus();
      return;
    }
    else {
      setErrorUaeHospitalSemenStocking(false);
    }

    if (
      formModel.importDate === null
    ) {
      setErrorImportDate(true);
      valid = false;

      importDateRef?.current?.focus();
      return;
    }
    else {
      setErrorImportDate(false);
    }

    if (
      formModel.shippingAgent === ""
    ) {
      setErrorShippingAgent(true);
      valid = false;

      shippingAgentRef?.current?.focus();
      return;
    }
    else {
      setErrorShippingAgent(false);
    }

    if (
      formModel.shippingAgent === 0
    ) {

      if (
        formModel.shippingAgentNameEn === ""
      ) {
        setErrorShippingAgentNameEn(true);
        valid = false;

        shippingAgentNameEnRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentNameEn(false);
      }

      if (
        formModel.shippingAgentNameAr === ""
      ) {
        setErrorShippingAgentNameAr(true);
        valid = false;

        shippingAgentNameArRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentNameAr(false);
      }

      if (
        formModel.shippingAgentEmail === ""
      ) {
        setErrorShippingAgentEmail(true);
        valid = false;

        shippingAgentEmailRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentEmail(false);
      }

      if (
        formModel.shippingAgentMobile === ""
      ) {
        setErrorShippingAgentMobile(true);
        valid = false;

        shippingAgentMobileRef?.current?.focus();
        return;
      }
      else {
        setErrorShippingAgentMobile(false);
      }
    }

    if (
      horsePassportAttachmentFile.length === 0
      && formModel.fileUrlHorsePassport === ""
    ) {
      setErrorHorsePassport(true);
      valid = false;

      horsePassportRef?.current?.focus();
      return;
    }
    else {
      setErrorHorsePassport(false);
    }

    if (
      letterSemenStorageCenterAttachmentFile.length === 0
      && formModel.fileUrlLetterSemenStorageCenter === ""
    ) {
      setErrorLetterSemenStorageCenter(true);
      valid = false;

      letterSemenStorageCenterRef?.current?.focus();
      return;
    }
    else {
      setErrorLetterSemenStorageCenter(false);
    }

    //term
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    //   || !checkedItems.option2
    //   || !checkedItems.option3
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckAllTerms", "Please Check All Terms")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=20&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;
        _status.current = status;

        let params = {
          id: id == null ? '' : id,
          importHorseFrozenSemenId: formModel.importHorseFrozenSemenId,
          ownerId: getUserID(),
          stallionName: formModel.stallionName,
          importCountry: formModel.importCountry,
          originCountry: formModel.originCountry,
          horseCategory: formModel.horseCategory,
          ueln: formModel.ueln,
          sire: formModel.sire,
          dam: formModel.dam,
          originStudbookRefNo: formModel.originStudbookRefNo,
          currentStudbookRefNo: formModel.currentStudbookRefNo,
          approvedCollectionCenter: formModel.approvedCollectionCenter,
          noStraws: formModel.noStraws,
          noDoses: formModel.noDoses,
          dispatchNumber: formModel.dispatchNumber,
          uaeHospitalSemenStocking: formModel.uaeHospitalSemenStocking,
          importDate: formModel.importDate != null ? dayjs(formModel.importDate).format("DD/MM/YYYY") : '',
          shippingAgent: formModel.shippingAgent !== 0 ? formModel.shippingAgent : '',
          shippingAgentNameEn: formModel.shippingAgentNameEn,
          shippingAgentNameAr: formModel.shippingAgentNameAr,
          shippingAgentEmail: formModel.shippingAgentEmail,
          shippingAgentMobile: formModel.shippingAgentMobile,
          horsePassportAttachmentFile: formModel.horsePassportAttachmentFile,
          letterSemenStorageCenterAttachmentFile: formModel.letterSemenStorageCenterAttachmentFile,
          residencePermitAttachmentFile: formModel.residencePermitAttachmentFile,
          status: status,
          ownerComment: formModel.ownerComment,
          buttonAction: buttonAction
        };

        dispatch(FetchCreateOrEditImportHorseFrozenSemenServiceRequestthunk(params));
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    setProfile(element);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "ImportHorseFrozenSemen" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchStudBookCountriesthunk(currentLanguage));

    dispatch(FetchGetShippingAgentsthunk());

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

        importHorseFrozenSemenId: getServicesRequestByIdData.importHorseFrozenSemenDto.importHorseFrozenSemenId,
        stallionName: getServicesRequestByIdData.importHorseFrozenSemenDto.stallionName,
        importCountry: getServicesRequestByIdData.importHorseFrozenSemenDto.importCountry,
        importCountryDrop: {
          label: getServicesRequestByIdData.importHorseFrozenSemenDto.importCountryName,
          value: getServicesRequestByIdData.importHorseFrozenSemenDto.importCountry,
        },
        originCountry: getServicesRequestByIdData.importHorseFrozenSemenDto.originCountry,
        originCountryDrop: {
          label: getServicesRequestByIdData.importHorseFrozenSemenDto.originCountryName,
          value: getServicesRequestByIdData.importHorseFrozenSemenDto.originCountry,
        },
        horseCategory: getServicesRequestByIdData.importHorseFrozenSemenDto.horseCategory,
        ueln: getServicesRequestByIdData.importHorseFrozenSemenDto.ueln == null ? "" : getServicesRequestByIdData.importHorseFrozenSemenDto.ueln,
        sire: getServicesRequestByIdData.importHorseFrozenSemenDto.sire,
        dam: getServicesRequestByIdData.importHorseFrozenSemenDto.dam,
        originStudbookRefNo: getServicesRequestByIdData.importHorseFrozenSemenDto.originStudbookRefNo,
        currentStudbookRefNo: getServicesRequestByIdData.importHorseFrozenSemenDto.currentStudbookRefNo,
        approvedCollectionCenter: getServicesRequestByIdData.importHorseFrozenSemenDto.approvedCollectionCenter,
        noStraws: getServicesRequestByIdData.importHorseFrozenSemenDto.noStraws,
        noDoses: getServicesRequestByIdData.importHorseFrozenSemenDto.noDoses,
        dispatchNumber: getServicesRequestByIdData.importHorseFrozenSemenDto.dispatchNumber,
        importDate: getServicesRequestByIdData.importHorseFrozenSemenDto.importDateTime != null ? dayjs(getServicesRequestByIdData.importHorseFrozenSemenDto.importDateTime).format("YYYY-MM-DD") : null,
        uaeHospitalSemenStocking: getServicesRequestByIdData.importHorseFrozenSemenDto.uaeHospitalSemenStocking,
        shippingAgent: getServicesRequestByIdData.importHorseFrozenSemenDto.shippingAgent,
        shippingAgentDrop: {
          label: getServicesRequestByIdData.importHorseFrozenSemenDto.shippingAgentName,
          value: getServicesRequestByIdData.importHorseFrozenSemenDto.shippingAgent,
        },

        filePathHorsePassport: getServicesRequestByIdData.importHorseFrozenSemenDto.horsePassportAttachmentFileModel.filePath,
        fileTypeHorsePassport: getServicesRequestByIdData.importHorseFrozenSemenDto.horsePassportAttachmentFileModel.fileType,
        fileNameHorsePassport: getServicesRequestByIdData.importHorseFrozenSemenDto.horsePassportAttachmentFileModel.fileName,
        fileUrlHorsePassport: getServicesRequestByIdData.importHorseFrozenSemenDto.horsePassportAttachmentFileModel.fileUrl,

        filePathLetterSemenStorageCenter: getServicesRequestByIdData.importHorseFrozenSemenDto.letterSemenStorageCenterAttachmentFileModel.filePath,
        fileTypeLetterSemenStorageCenter: getServicesRequestByIdData.importHorseFrozenSemenDto.letterSemenStorageCenterAttachmentFileModel.fileType,
        fileNameLetterSemenStorageCenter: getServicesRequestByIdData.importHorseFrozenSemenDto.letterSemenStorageCenterAttachmentFileModel.fileName,
        fileUrlLetterSemenStorageCenter: getServicesRequestByIdData.importHorseFrozenSemenDto.letterSemenStorageCenterAttachmentFileModel.fileUrl,

        filePathResidencePermit: getServicesRequestByIdData.importHorseFrozenSemenDto.residencePermitAttachmentFileModel.filePath,
        fileTypeResidencePermit: getServicesRequestByIdData.importHorseFrozenSemenDto.residencePermitAttachmentFileModel.fileType,
        fileNameResidencePermit: getServicesRequestByIdData.importHorseFrozenSemenDto.residencePermitAttachmentFileModel.fileName,
        fileUrlResidencePermit: getServicesRequestByIdData.importHorseFrozenSemenDto.residencePermitAttachmentFileModel.fileUrl,

        ownerComment: getServicesRequestByIdData.importHorseFrozenSemenDto.ownerComment != null ? getServicesRequestByIdData.importHorseFrozenSemenDto.ownerComment : "",
      });

      //another owner
      if (
        getServicesRequestByIdData.importHorseFrozenSemenDto.ownerId !==
        getServicesRequestByIdData.importHorseFrozenSemenDto.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.importHorseFrozenSemenDto.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.importHorseFrozenSemenDto.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.importHorseFrozenSemenDto.ownerId
          )[0].value,
        });
      }

      //options
      // setCheckedItems({
      //   option1: true,
      //   option2: true,
      //   option3: true,
      // });
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${importHorseFrozenSemenData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${importHorseFrozenSemenData.id}&paymentType=20&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${importHorseFrozenSemenData.id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {/* content page */}
      <div className={serviceRequestHeadContainer}>

        {/* update Arabian Horse Data */}
        <h2 className={serviceRequestTitle}>

          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>

        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[

                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.stallionDetails", "Stallion Details")}>
        <label>
          {translate("web.horseCategory", "Horse Category")}
        </label>
        <div className="row mx-0" >

          <div className={eformCheckBox}>
            <NetaqInput
              name={"horseCategory"}
              type={"radioServiceRequest"}
              value={"Show"}
              label={`${translate("web.isShowCategory", "Is Show Category")}-`}
              onChange={handleFormChange}
              checked={
                formModel.horseCategory === "Show"
              }
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>

          <div className={eformCheckBox}>
            <NetaqInput
              name={"horseCategory"}
              type={"radioServiceRequest"}
              value={"Race"}
              label={`${translate("web.isRaceCategory", "Is Race Category")}-`}
              onChange={handleFormChange}
              checked={
                formModel.horseCategory === "Race"
              }
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.stallionName", "Stallion Name")}
            name={"stallionName"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "stallionName")}
            value={formModel.stallionName}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={stallionNameRef}
          />
          {
            errorStallionName &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <label>
            {translate("web.importFrom", "Import From")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.chooseCountry", "Choose Country"),
                value: null,
              },
              ...(!!studBookCountries &&
                studBookCountries.map((a) => ({
                  label: a.text,
                  value: a.value,
                }))),
            ]}
            value={formModel.importCountryDrop}
            onChange={(e) => handleFormChange(e, "importCountry")}
            placeholder={translate("web.chooseCountry", "Choose Country")}
            name={"importCountry"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"importCountry"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={importCountryRef}
          />
          {
            errorImportCountry && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>

        <div className={eformInput}>
          <label>
            {translate("web.originFrom", "Origin From")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.chooseCountry", "Choose Country"),
                value: null,
              },
              ...(!!studBookCountries &&
                studBookCountries.map((a) => ({
                  label: a.text,
                  value: a.value,
                }))),
            ]}
            value={formModel.originCountryDrop}
            onChange={(e) => handleFormChange(e, "originCountry")}
            placeholder={translate("web.chooseCountry", "Choose Country")}
            name={"originCountry"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"originCountry"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={originCountryRef}
          />
          {errorOriginCountry && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>



        <div className={eformInput}>
          <NetaqInput
            label={translate("web.ueln", "UELN")}
            name={"ueln"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.ueln}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.sire", "Sire")}
            name={"sire"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "sire")}
            value={formModel.sire}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={sireRef}
          />
          {
            errorSire &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.dam", "Dam")}
            name={"dam"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "dam")}
            value={formModel.dam}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={damRef}
          />
          {
            errorDam &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.originStudbookRefNo", "Origin Studbook Ref.No")}
            name={"originStudbookRefNo"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.originStudbookRefNo}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={originStudbookRefNoRef}
          />
          {
            errorOriginStudbookRefNo &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.currentStudbookRefNo", "Current Studbook Ref.No")}
            name={"currentStudbookRefNo"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.currentStudbookRefNo}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={currentStudbookRefNoRef}
          />
          {
            errorCurrentStudbookRefNo &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.approvedCollectionCenterDetails", "Approved Collection Center Details")}>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.approvedCollectionCenter", "Approved Collection Center")}
            name={"approvedCollectionCenter"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.approvedCollectionCenter}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={approvedCollectionCenterRef}
          />
          {
            errorApprovedCollectionCenter &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            name={"noStraws"}
            key={"noStraws"}
            type={"number"}
            required={true}
            value={formModel.noStraws}
            minValue={1}
            label={translate("web.noStraws", "No Of Straws")}
            onChange={handleFormChange}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={noStrawsRef}
          />
          {
            errorNoStraws &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            name={"noDoses"}
            key={"noDoses"}
            type={"number"}
            required={true}
            value={formModel.noDoses}
            minValue={1}
            label={translate("web.noDoses", "No Of Doses")}
            onChange={handleFormChange}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={noDosesRef}
          />
          {
            errorNoDoses &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.dispatchNumber", "Dispatch Number")}
            name={"dispatchNumber"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.dispatchNumber}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={dispatchNumberRef}
          />
          {
            errorDispatchNumber &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.uaeHospitalSemenStocking", "UAE Hospital Semen Stocking")}
            name={"uaeHospitalSemenStocking"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.uaeHospitalSemenStocking}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={uaeHospitalSemenStockingRef}
          />
          {
            errorUaeHospitalSemenStocking &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>

        <div className={eformInput}>
          <NetaqInput
            htmlTags={
              formModel.importDate ?
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  {
                    dayjs(formModel.importDate).format("DD/MM/YYYY")
                  }
                </p> :
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  DD/MM/YYYY
                </p>
            }
            name={"importDate"}
            type={"normalDateService"}
            label={translate("web.importDate", "Date Of Import")}
            onChange={handleFormChange}
            value={formModel.importDate}
            required={true}
            maxDate={dayjs().format("YYYY-MM-DD")}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={importDateRef}
          />
          {
            errorImportDate &&
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          }
        </div>
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.shippingAgent", "Shipping Agent")}>
        <div className={eformInput}>
          <label>
            {translate("web.shippingAgent", "Shipping Agent")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.shippingAgent", "Shipping Agent"),
                value: null,
              },
              ...(!!getShippingAgentsData &&
                getShippingAgentsData.map((a) => ({
                  label: a.text,
                  text: a.text,
                  value: a.value,
                }))),
              {
                label: translate("web.other", "Other"),
                text: translate("web.other", "Other"),
                value: 0,
              }
            ]}
            value={formModel.shippingAgentDrop}
            onChange={(e) => handleFormChange(e, "shippingAgent")}
            placeholder={translate("web.shippingAgent", "Shipping Agent")}
            name={"shippingAgent"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"shippingAgent"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={shippingAgentRef}
          />
          {errorShippingAgent && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        {formModel.shippingAgent === 0 &&
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.name", "Name") + " (EN)"}
                name={"shippingAgentNameEn"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "shippingAgentNameEn")}
                value={formModel.shippingAgentNameEn}
                required={true}
                ref={shippingAgentNameEnRef}
              />
              {errorShippingAgentNameEn &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.name", "Name") + " (AR)"}
                name={"shippingAgentNameAr"}
                type={"text"}
                onChange={handleFormChange}
                value={formModel.shippingAgentNameAr}
                required={true}
                ref={shippingAgentNameArRef}
              />
              {errorShippingAgentNameAr &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.email", "Email")}
                name={"shippingAgentEmail"}
                type={"text"}
                onChange={handleFormChange}
                value={formModel.shippingAgentEmail}
                required={true}
                ref={shippingAgentEmailRef}
              />
              {errorShippingAgentEmail &&
                <p style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </p>
              }
            </div>
            <div className={eformInput}>
              <NetaqInput
                type={'phone'}
                value={formModel.shippingAgentMobile}
                label={translate("web.smsPhoneNo", "Mobile No")}
                name={'shippingAgentMobile'}
                placeholder={'971xxxxxxxxx'}
                required={true}
                onChange={setPhoneNumber}
                setIsPhoneNumberValid={setIsPhoneNumberValid}
                ref={shippingAgentEmailRef}
              />
              {!isPhoneNumberValid &&
                <div className='text-danger'>
                  {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                </div>
              }
              {errorShippingAgentMobile && (
                <span
                  style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
          </>
        }
      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.uploadDocument", "Upload Document")}>
        <div className={eformInput}>
          <label>
            {translate("web.clearPassportCopy", "Clear Passport Copy")}
            <i className=" colorred"> *</i>
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathHorsePassport &&
                !!formModel.fileUrlHorsePassport &&
                horsePassportAttachmentFile.length === 0
                ? [
                  {
                    file: formModel?.fileUrlHorsePassport,
                    name: formModel?.fileNameHorsePassport,
                  },
                ]
                : horsePassportAttachmentFile
            }
            isServer={
              !!formModel.filePathHorsePassport &&
                !!formModel.fileUrlHorsePassport &&
                horsePassportAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadHorsePassportChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={horsePassportRef}
          />
          {
            errorHorsePassport && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>

        <div className={eformInput}>
          <label>
            {translate("web.letterSemenStorageCenter", "Letter Semen Storage Center")}
            <i className=" colorred"> *</i>
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathLetterSemenStorageCenter &&
                !!formModel.fileUrlLetterSemenStorageCenter &&
                letterSemenStorageCenterAttachmentFile.length === 0
                ? [
                  {
                    file: formModel?.fileUrlLetterSemenStorageCenter,
                    name: formModel?.fileNameLetterSemenStorageCenter,
                  },
                ]
                : letterSemenStorageCenterAttachmentFile
            }
            isServer={
              !!formModel.filePathLetterSemenStorageCenter &&
                !!formModel.fileUrlLetterSemenStorageCenter &&
                letterSemenStorageCenterAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadLetterSemenStorageCenterChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={letterSemenStorageCenterRef}
          />
          {
            errorLetterSemenStorageCenter && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>

        <div className={eformInput}>
          <label>
            {translate("web.residencePermit", "Residence Permit")}
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathResidencePermit &&
                !!formModel.fileUrlResidencePermit &&
                residencePermitAttachmentFile.length === 0
                ? [
                  {
                    file: formModel?.fileUrlResidencePermit,
                    name: formModel?.fileNameResidencePermit,
                  },
                ]
                : residencePermitAttachmentFile
            }
            isServer={
              !!formModel.filePathResidencePermit &&
                !!formModel.fileUrlResidencePermit &&
                residencePermitAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadResidencePermitChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
          />
          {
            errorResidencePermit && (
              <span style={{ color: "red" }}>
                {translate("web.requiredField", "Required Field")}
              </span>
            )}
        </div>
      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            // eahs Comment
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName !== "SentBack" ? true : false}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms} >
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.importHorseFrozenSemenNote1",
              "Import Horse Frozen Semen Note1"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.importHorseFrozenSemenNote2",
              "Import Horse Frozen Semen Note2"
            )}
            name="option2"
            checked={checkedItems.option2}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option3"
            checked={checkedItems.option3}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons*/}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {(
          (action == null || action === "edit")
          ||
          (
            action === "approve"
            &&
            (
              formModel.eventName === "SentBack"
              ||
              (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
            )
          )
        ) && (
            <>
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn onClick={() => handelFormSubmit("Draft", "", 'Draft')}
                  isDisabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  } />
              }

              {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false} onClick={() =>
                    handelFormSubmit("Draft", "no", 'Pay')
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  } />
              )}

              {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", 'Pay')
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {(getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                <SubmitServiceBtn
                  onClick={() =>
                    handelFormSubmit("Submit", "", 'Submit')
                  }
                  isDisabled={
                    getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                      ? false
                      : true
                  }
                />
              )}
            </>
          )}
      </div>
    </>
  );
}
